import React, { useState } from "react";
import TableLite from "../../../../../Components/TableLite";
import { useQuery } from "@tanstack/react-query";
import { fetchCompanyLogs } from "../../../contexts/api";

// Helper function to truncate text
const truncateText = (text, maxLength) => {
	if (!text || text.length <= maxLength) return text;
	return `${text.substring(0, maxLength)}...`;
};

const SeededCompanyLogsTable = () => {
	const [currentPage, setCurrentPage] = useState(1);
	const itemsPerPage = 25;

	const {
		data: logs,
		isLoading,
		error,
	} = useQuery({
		queryKey: ["company-logs"],
		queryFn: () => fetchCompanyLogs(),
	});

	if (isLoading) {
		return <div>Loading...</div>;
	}

	if (error) {
		return <div>Error: {error.message}</div>;
	}

	if (!logs || logs.length === 0) {
		return null;
	}
	const totalItems = logs.data.data.length;
	const totalPages = Math.ceil(totalItems / itemsPerPage);
	const startIndex = (currentPage - 1) * itemsPerPage;
	const endIndex = startIndex + itemsPerPage;
	const currentPageData = logs.data.data.slice(startIndex, endIndex);

	const handlePageChange = (page) => {
		setCurrentPage(page);
	};

	const columns = [
		{ id: "user", label: "User", getter: (row) => row.user },
		{ id: "environment", label: "Environment", getter: (row) => row.environment },
		{
			id: "companyName",
			label: "Company Name",
			width: "200px",
			getter: (row) => (
				<div
					title={row.company_name}
					style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
				>
					{truncateText(row.company_name, 20)}
				</div>
			),
		},
		{
			id: "companyId",
			label: "Company ID",
			width: "150px",
			getter: (row) => (
				<div
					title={row.company_id}
					style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
				>
					{row.company_id}
				</div>
			),
		},
		{
			id: "configName",
			label: "Config Name",
			width: "180px",
			getter: (row) => (
				<div
					title={row.config_name}
					style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
				>
					{truncateText(row.config_name, 20)}
				</div>
			),
		},
		{ id: "timestamp", label: "Timestamp", getter: (row) => row.timestamp },
	];

	return (
		<>
			<TableLite rows={currentPageData || []} columns={columns} emptyMessage="No seeded company logs found" />
			{totalPages > 1 && (
				<div style={{ marginTop: "20px", display: "flex", justifyContent: "center" }}>
					<Paginator
						currentPage={currentPage}
						pageCount={totalPages}
						onClick={handlePageChange}
						showSlider={false}
						isRequesting={isLoading}
					/>
				</div>
			)}
			{totalItems > 0 && (
				<div style={{ marginTop: "10px", textAlign: "center", fontSize: "14px", color: "#666" }}>
					Showing {startIndex + 1}-{Math.min(endIndex, totalItems)} of {totalItems} logs
				</div>
			)}
		</>
	);
};

export default SeededCompanyLogsTable;
